'use client'
import { CloseIcon } from '../../../icons'
import { AnimatePresence, HTMLMotionProps, motion } from 'framer-motion'
import React from 'react'
import { Button, ButtonVariants, Text } from '../../../atoms'
import { getToastIcon } from '../helpers/getToastIcon'
import { ToastOption, ToastVariant } from '../../../../types'

const TOAST_STYLING: { [key: string]: string } = {
    COLOR: 'contrast bg-primary text-text-default',
    BOX: 'border-1 border-shade-opacity-200 shadow-drop-lg',
    LAYOUT: 'flex justify-between fixed bottom-[72px] z-50',
    SIZE: 'min-h-[3rem] max-w-xl',
    SPACING: 'p-0',
}

export const Toast = ({ id, message, variant, actionText, onAction, onRemove }: ToastOption): JSX.Element => {
    const loading: boolean = variant === ToastVariant.LOADING
    const animation: HTMLMotionProps<'dialog'> = {
        initial: { bottom: -50 },
        animate: { bottom: 72, transition: { duration: 0.5 } },
        exit: { bottom: -50, transition: { duration: 0.25 } },
    }

    const getClassNamesForParent = (): string => Object.values(TOAST_STYLING).join(' ')

    return (
        <AnimatePresence>
            {message && (
                <motion.dialog {...animation} className={getClassNamesForParent()} open>
                    <div className="px-4 py-3 flex items-center">
                        {variant && !!getToastIcon(variant) && (
                            <span className="w-6 mr-2 flex">{getToastIcon(variant)}</span>
                        )}
                        <Text className="line-clamp-2">{message}</Text>
                    </div>

                    {actionText && onAction && (
                        <Button variant={ButtonVariants.TERTIARY} className="px-4 py-3" onClick={() => onAction()}>
                            {actionText}
                        </Button>
                    )}

                    {!loading && onRemove && (
                        <div className="border-l border-shade-600 flex items-center">
                            <Button
                                variant={ButtonVariants.TERTIARY}
                                className="px-4 py-[12px]"
                                onClick={() => onRemove(id)}
                                icon={<CloseIcon />}
                            />
                        </div>
                    )}
                </motion.dialog>
            )}
        </AnimatePresence>
    )
}
